var _path;
function _extends() { return _extends = Object.assign ? Object.assign.bind() : function (n) { for (var e = 1; e < arguments.length; e++) { var t = arguments[e]; for (var r in t) ({}).hasOwnProperty.call(t, r) && (n[r] = t[r]); } return n; }, _extends.apply(null, arguments); }
import * as React from "react";
const SvgFile = props => /*#__PURE__*/React.createElement("svg", _extends({
  viewBox: "0 0 24 24",
  fill: "currentColor",
  xmlns: "http://www.w3.org/2000/svg"
}, props), _path || (_path = /*#__PURE__*/React.createElement("path", {
  fillRule: "evenodd",
  d: "M7.083 4.7c-.177 0-.383.163-.383.443v13.714c0 .28.206.443.383.443h10.833c.177 0 .384-.163.384-.443V7.707L15.449 4.7H7.083ZM5.3 5.143c0-.982.763-1.843 1.783-1.843h8.968L19.7 7.15v11.707c0 .982-.764 1.843-1.784 1.843H7.083c-1.02 0-1.783-.86-1.783-1.843V5.143Z"
})));
export { SvgFile as ReactComponent };
export default __webpack_public_path__ + "e317063fdb94a6ff2bdd31fdaa91215c.svg";